import { render, staticRenderFns } from "./ManageHelpfulLink.vue?vue&type=template&id=e811a72a"
import script from "./ManageHelpfulLink.vue?vue&type=script&lang=ts"
export * from "./ManageHelpfulLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports